import { Box, Typography } from "@mui/material";
import StarsIcon from "@mui/icons-material/Stars";
import { CourseBlock, starsList } from "../../../Pages/CourseTarget/courseBlocks";
import { mathsImg } from "./img";

/** 數學科 > 教師專業發展 */
export const mathsDevelopmentBlocks: CourseBlock[] = [
    {
        type: "heading",
        text: "重視發展數學科研工作，提升教師教學能量。教師團隊樂於分享，積極建立教師學習社群，懷敬業樂群的心。",
        variant: "h5",
        color: "#F02602",
        icon: "triangle",
    },
    {
        type: "paragraph",
        data: ["2026-27年度8月 誠邀榮獲24-25行政長官卓越教學獎得主，陳嘉敏老師分享如何在校內推動數學建模教師專業發展工作坊。"],
        images: [mathsImg.development2627_1],
        position: "down",
        imageHeight: "480px",
    },
    {
        type: "paragraph",
        data: ["2025-26年度8月 誠邀柯志明先生分享POLYPAD教材製作教師專業發展工作坊及誠邀出版商介紹VR教師體驗工作坊。"],
        images: [mathsImg.development2627_2, mathsImg.development2627_3],
        position: "down", imageHeight: "450px",
    },
    {
        type: "paragraph",
        data: ["2025年 黃清洪副校為QTNS計畫內友校同工分享素養教學課堂，介紹數學科如何加入中華文化元素。"],
        images: [mathsImg.development2526_1],
        position: "down",
        mainCardProps: {
            imgSx: { maxWidth: "800px", width: "100%", height: "auto", display: "block", margin: "0 auto" },
            noHoverAni: true,
        },
    },
    {
        type: "paragraph",
        data: [
            "2024年 蔡碧卿老師﹑吳雪蓮老師及陳天呼老師榮獲教聯會邀請主講「優秀教師課堂分享系列」ZOOM講座 : 課前、中、後全方位閲讀:創故事，學數學。",
            "2023年 蔡碧卿老師﹑黃佩怡老師獲教聯會邀請主講「優秀教師課堂分享系列」ZOOM講座:以跨學科培養數學素養。",
            "2021年黃清洪副校﹑文寳珊老師﹑張儀老師及蔡碧卿老師獲邀主講「行政長官卓越教學獎薈萃分享會",
        ],
        images: [mathsImg.development1, mathsImg.development2],
        position: "down",
    },
    {
        type: "paragraph",
        data: ["2014年數學科主任曾獲行政長官卓越教學教師協會邀請主講<知行合一>教師工作坊。"],
        images: [mathsImg.development3],
        position: "left",
        imageHeight: "350px",
    },
    {
        type: "paragraph",
        title: (
            <Box sx={{ display: "flex", alignItems: "center", py: 1 }}>
                <StarsIcon sx={{ mr: 1, color: "#F02602" }} />
                <Typography variant="h4" align="left" sx={{ color: "#F02602" }}>
                    專家指導，擴闊專業視野:
                </Typography>
            </Box>
        ),
        data: [
            "24-25年度8月誠邀誠邀創科展入圍學校秀明小學:楊楚慧主任﹑方俊輶老師﹑李嘉正老師，與僑小學就STEAM課程分享與交流。主講:「校本STEAM課程發展及展望﹑數學科如何與STEAM作有機結合﹑資訊科技與生活．聯繫生活．發揮創意-BIBU消防屋」",
        ],
        images: [mathsImg.development0a, mathsImg.development0b],
        position: "down",
        imageHeight: "350px",
    },
    {
        type: "paragraph",
        data: ["24-25年  1月份，1月份，兩次編程工作坊:MICROBIT﹑SCRATCH(跨科學習-當日中﹑英﹑常同事均有參與"],
        images: [mathsImg.development2526_2],
        position: "left",
        imageHeight: "250px",
    },
    {
        type: "paragraph",
        data: [
            "23-24年度8月誠邀致力推廣價值觀教育的馬正源老師親臨。他曾獲香港教育大學頒授傑出生命教育教案設計獎﹑香港大學頒授國際傑出電子教學獎金獎及教育評議會執委。他為我校主講:「如何在數學教學中滲入中華文化元素。」講座，有助推動科組專業發展及對價值觀教育有更深入的認識。",
        ],
        images: [mathsImg.developmentImg1],
        position: "right",
        imageHeight: "350px",
    },
    {
        type: "paragraph",
        data: [
            "22-23年度6月 誠邀教育局資訊科技教育卓越中心借調老師陳佩筠老師及江溢晉老師，到校主講「 使用應用程式促進網上學與教的電子評估( Pear Deck)」工作坊，這有助推動本校的電子學習。",
        ],
        images: [mathsImg.developmentImg2],
        position: "left",
        imageHeight: "350px",
    },
    {
        type: "custom",
        node: (
            <>
                {starsList([
                    "重視發展數學科研工作，提升教師教學能量。教師團隊樂於分享，積極建立教師學習社群，懷敬業樂群的心。",
                ])}
                <img
                    src={mathsImg.development4}
                    alt=""
                    style={{ width: "48%", marginRight: "2%", maxHeight: "350px", objectFit: "contain" }}
                />
                <img
                    src={mathsImg.development5}
                    alt=""
                    style={{ width: "48%", maxHeight: "350px", objectFit: "contain" }}
                />
            </>
        ),
    },
    {
        type: "paragraph",
        title: starsList(["22年8月下旬，誠邀番禺會所華仁小學李志豪老師﹑簡嘉茜老師"]),
        data: ["為我校分享「善用表現分析系統，推動「促進學習的評估」和「作為學習的評估」教師專業發展講座。"],
        images: [mathsImg.development6, mathsImg.development7],
        position: "down",
        imageHeight: "450px",
    },
    {
        type: "paragraph",
        data: [
            "校外方面，我們分別獲教育局及優質教育基金邀請，成為「專業發展學校計劃」及「QTN-S主題網絡計劃」的統籌學校，透過不同形式的協作，例如共同備課、同儕觀課、教學經驗分享、教學資源共享等互動活動，提升參與教師的專業能量，優化教學效能，建立同儕協作文化，使學校成為學習型組織。",
        ],
        images: [mathsImg.development8a, mathsImg.development8b, mathsImg.development8c],
        position: "down",
        imageHeight: "400px",
    },
    {
        type: "paragraph",
        title: starsList(["積極參與內地及外地交流活動，增廣見聞，掌握教育新命題。"]),
        data: ["科課程主任積極參與STEM考察交流團:2024日本東京教師專業發展4天團"],
        images: [mathsImg.development9],
        position: "left",
    },
    {
        type: "paragraph",
        data: ["科課科主任積極參與STEM深圳考察交流團2017"],
        images: [mathsImg.development9b],
        position: "right",
    },
    {
        type: "paragraph",
        data: ["吳佳筠校長帶領數學科科主任參加芬蘭交流團2018，了解跨學科學習的理念。"],
        images: [mathsImg.development10],
        position: "left",
    },
];
